export default function(request, reject, rootAddress) {
  var service = {};
  /**
		获得基本信息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/get_config?is_wx=1&token=b7a1202c33bdd9fa43a5e449b4111633

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "uid": "66f041d5c35c8fe4977f926db5f3e93e",
	        "phone": "169***619",
	        "invite_count": 2,
	        "add_wx_manager": 1,
	        "add_wx_account": 1,
	        "share_friend": 1,
	        "lottery_time": 0,
	        "subscribe_total": 37726,
	        "m_login_token": "9bd5a37e1a353e9eb6f7fe1697178e98",
	        "is_subscribe_msg": 1,
	        "session_id": "eIoCYKGNchYOKqP2HhHHPwKfAYDAhDhZc9GmF6uQ",
	        "request_id": "f9cbb029767cb619f4846c112e21b7c5ebc2a0b1"
	    }
	 }
		*/
  service.getConfig = function(is_wx, token) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/get_config', {
      is_wx: is_wx /*  是否是微信小程序（1：是，0：不是），不传该字段默认为0 */ ,
      token: token /*  小程序二维码token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "add_wx_account": "是否已完成添加微信公众号任务（1：是，0：否）",
            "add_wx_manager": "是否已完成添加微信管家任务（1：是，0：否）",
            "invite_count": "邀请好友预约总数",
            "is_subscribe_msg": "是否已订阅微信信息（is_wx为1才会有该字段，1：是，0：否）",
            "lottery_time": "抽奖次数",
            "m_login_token": "移动端登录token",
            "phone": "脱敏手机号",
            "share_friend": "是否已完成分享朋友圈任务（1：是，0：否）",
            "subscribe_total": "预约总数",
            "open_id": "微信openid",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20124",
        "description": "该二维码已被使用请重新扫码授权登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		发送手机号验证码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/get_phone_code?phone=15913351519

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "jl4ltqj2CoYKGD62M1lsCAukVZavfX51J1r5eULB",
	        "request_id": "776beceadcb49ba2799f8a39b4703d784ec29646"
	    }
	 }
		*/
  service.getPhoneCode = function(params) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/get_phone_code', {
      ...params
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10303",
        "description": "短信内容为空"
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10308",
        "description": "短信验证码发送数量达到每日上限"
      }, {
        "code": "-10309",
        "description": "短信验证码发送频率太快"
      }, {
        "code": "-10316",
        "description": "参数缺失"
      }, {
        "code": "-10317",
        "description": "参数类型错误"
      }, {
        "code": "-10601",
        "description": "图片验证码为空"
      }, {
        "code": "-10602",
        "description": "图片验证码错误"
      }, {
        "code": "-10603",
        "description": "极验验证失败"
      }, {
        "code": "-10604",
        "description": "图片验证码参数错误"
      }, {
        "code": "-10605",
        "description": "图片验证码已过期，请重新刷新"
      }, {
        "code": "-10606",
        "description": "顶象验证失败"
      }, {
        "code": "-12304",
        "description": "手机号OpenId参数缺失"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		预约
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/subscribe?phone=16913361617&code=112233&platform=iOS&invitee_uid=66f041d5c35c8fe4977f926db5f3e93e&ua_os=windows&utm_source=17173&device_id=deid123123123&operate_from=pc

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_frist": 1,
	        "uid": "66f041d5c35c8fe4977f926db5f3e93e",
	        "phone": "169***619",
	        "session_id": "jl4ltqj2CoYKGD62M1lsCAukVZavfX51J1r5eULB",
	        "request_id": "f23407b77700733cb95d9c516c28bb3cd551c113"
	    }
	 }
		*/
  service.subscribe = function(code, device_id, invitee_uid, operate_from, phone, platform, ua_os, utm_source) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/subscribe', {
      code: code /*  手机号验证码 */ ,
      device_id: device_id /*  设备id */ ,
      invitee_uid: invitee_uid /*  分享人uid */ ,
      operate_from: operate_from /*  （pc=电脑端，h5=h5端） */ ,
      phone: phone /*  手机号 */ ,
      platform: platform /*  平台类型（iOS 或 Android） */ ,
      ua_os: ua_os /*  ua中的操作系统 */ ,
      utm_source: utm_source /*  utm_source */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "is_frist": "是否首次预约（1：是，0：否）",
            "phone": "脱敏手机号",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-10305",
        "description": "短信发送手机号码为空"
      }, {
        "code": "-10306",
        "description": "短信发送手机号码格式错误"
      }, {
        "code": "-10310",
        "description": "短信验证码不存在"
      }, {
        "code": "-10311",
        "description": "短信验证码为空"
      }, {
        "code": "-10312",
        "description": "短信验证码错误"
      }, {
        "code": "-10313",
        "description": "短信验证码超过有效期"
      }, {
        "code": "-10314",
        "description": "短信验证码已失效"
      }, {
        "code": "-10315",
        "description": "短信验证码已经被验证过，请重新获取"
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20106",
        "description": "无效的分享id"
      }, {
        "code": "-20107",
        "description": "平台类型错误"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		完成相关任务
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/done_mission?type=3&ua_os=ios&entrance=pc&device_id=dis123456aaa

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "jl4ltqj2CoYKGD62M1lsCAukVZavfX51J1r5eULB",
	        "request_id": "41d5276385dd42253c351271bc2aa88a0b346e0f"
	    }
	 }
		*/
  service.doneMission = function(device_id, entrance, type, ua_os) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/done_mission', {
      device_id: device_id /*  设备id */ ,
      entrance: entrance /*  入口（pc=电脑端, h5=移动端, official=公众号） */ ,
      type: type /*  任务类型:1=添加微信管家,2=关注微信公众号,3=分享至朋友圈 */ ,
      ua_os: ua_os /*  ua中的操作系统 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20103",
        "description": "任务类型异常"
      }, {
        "code": "-20104",
        "description": "您已完成该任务"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		分享页基本信息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/share_config?share_uid=9fc4b28ea5ede8a4506438da610ee727

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "phone": "169***617",
	        "session_id": "PJvoo9W5vztqtnWrlmwD7r48tnOeoqNn0BxE8Mfo",
	        "request_id": "78ccbf962b2cb9c74cc073f8a466f993c931bc09"
	    }
	 }
		*/
  service.shareConfig = function(share_uid) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/share_config', {
      share_uid: share_uid /*  分享人uid */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "phone": "脱敏手机号"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20105",
        "description": "分享id不能为空"
      }, {
        "code": "-20106",
        "description": "无效的分享id"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		抽奖
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/lottery?is_wx=0

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_id": 2,
	        "prize_type": 2,
	        "session_id": "jl4ltqj2CoYKGD62M1lsCAukVZavfX51J1r5eULB",
	        "request_id": "b8f4b4d9b2b31ba47e4dcbee6449b020c8f2d76f"
	    }
	 }
		*/
  service.lottery = function(is_wx, device_id, entrance, ua_os) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/lottery', {
      is_wx: is_wx /*  是否是微信小程序（1：是，0：不是），不传该字段默认为0 */ ,
      device_id: device_id /*  设备id */ ,
      entrance: entrance /*  入口（pc=电脑端, h5=移动端, official=公众号） */ ,
      ua_os: ua_os /*  ua中的操作系统 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "prize_id": "奖励id",
            "prize_type": "奖励类型:1=虚拟奖励,2=实物奖励"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20108",
        "description": "抽奖次数不足"
      }, {
        "code": "-20109",
        "description": "请先完善配置"
      }, {
        "code": "-20110",
        "description": "网络异常，请稍后重试"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		我的奖励
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/my_prize?is_wx=0

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "virtual_prize": [
	            {
	                "create_time": 1711078511,
	                "prize_id": "4"
	            },
	            {
	                "create_time": 1711078519,
	                "prize_id": "4"
	            },
	            {
	                "create_time": 1711078523,
	                "prize_id": "8"
	            },
	            {
	                "create_time": 1711078527,
	                "prize_id": "8"
	            },
	            {
	                "create_time": 1711078532,
	                "prize_id": "8"
	            }
	        ],
	        "truth_prize": [
	            {
	                "create_time": 1711078515,
	                "prize_id": "3"
	            }
	        ],
	        "address_info": {
	            "addressee": "小阿飞",
	            "contact_phone": "18316023268",
	            "address": "广东珠海金山软件园"
	        },
	        "session_id": "2iO8EqALssyRg2tfcEMUIL2InDrd2E72s3fBOjZb",
	        "request_id": "c56ff2acb8c52ff11d76b4798491634f9867938d"
	    }
	 }
		*/
  service.myPrize = function(is_wx) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/my_prize', {
      is_wx: is_wx /*  是否是微信小程序（1：是，0：不是），不传该字段默认为0 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "address_info": "地址信息",
            "truth_prize": "实物奖励",
            "virtual_prize": "虚拟奖励"
          },
          "data{}.address_info{}": {
            "address": "收件地址",
            "addressee": "收件人",
            "contact_phone": "联系手机号:敏感信息"
          },
          "data{}.truth_prize[]": {
            "create_time": "获得奖励时间",
            "prize_id": "奖励id（对应奖励未确定）"
          },
          "data{}.virtual_prize[]": {
            "create_time": "获得奖励时间",
            "prize_id": "奖励id"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		设置收件地址
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/set_address?addressee=小阿飞&contact_phone=18316023268&address=广东珠海金山软件园

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "2iO8EqALssyRg2tfcEMUIL2InDrd2E72s3fBOjZb",
	        "request_id": "37c4379eb91226c0b440dabbf6887cc3b6c237bb"
	    }
	 }
		*/
  service.setAddress = function(addressee, contact_phone, address) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/set_address', {
      addressee: addressee /*  收件人 */ ,
      contact_phone: contact_phone /*  联系手机号 */ ,
      address: address /*  收件地址 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10101",
        "description": "手机号码为空"
      }, {
        "code": "-10102",
        "description": "手机号码格式错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20111",
        "description": "您已填写收款地址，无法重新填写"
      }, {
        "code": "-20112",
        "description": "您未获得实物奖励"
      }, {
        "code": "-20113",
        "description": "请填写完整的收件信息"
      }, {
        "code": "-20114",
        "description": "收件人名称涉及敏感词汇，请修改"
      }, {
        "code": "-20115",
        "description": "收件地址涉及敏感词汇，请修改"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		小程序预约
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/subscribe_by_wx?code=123123

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_frist": 0,
	        "uid": "66f041d5c35c8fe4977f926db5f3e93e",
	        "phone": "169***619",
	        "session_id": "PJvoo9W5vztqtnWrlmwD7r48tnOeoqNn0BxE8Mfo",
	        "request_id": "bc274accfff188c0d97a771341ea694a0ef07013"
	    }
	 }
		*/
  service.subscribeByWx = function(code, token, operate_from, platform, ua_os, utm_source) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/subscribe_by_wx', {
      code: code /*  微信获取绑定手机号返回code */ ,
      token: token /*  小程序二维码token信息 */ ,
      operate_from: operate_from /*  （pc=电脑端，h5=h5端） */ ,
      platform: platform /*  平台类型（iOS 或 Android） */ ,
      ua_os: ua_os /*  ua中的操作系统 */ ,
      utm_source: utm_source /*  utm_source */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "is_frist": "是否首次预约（1：是，0：否）",
            "phone": "脱敏手机号",
            "uid": "分享uid"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20101",
        "description": "该手机号未完成预约"
      }, {
        "code": "-20106",
        "description": "无效的分享id"
      }, {
        "code": "-20107",
        "description": "平台类型错误"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20117",
        "description": "获取微信绑定手机号失败"
      }, {
        "code": "-20124",
        "description": "该二维码已被使用请重新扫码授权登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		订阅消息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/subscribe_msg

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "PJvoo9W5vztqtnWrlmwD7r48tnOeoqNn0BxE8Mfo",
	        "request_id": "7f0019a0f721f41ffc342291c212e85fc28e1b79"
	    }
	 }
		*/
  service.subscribeMsg = function() {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/subscribe_msg', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10201",
        "description": "系统处理中..."
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20119",
        "description": "您已订阅信息"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		退出登录
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/logout

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "session_id": "ZQvzwK2p0qjgaDEyFEmbDip8yb3adTSMe1aMeoDQ",
	        "request_id": "ee47e9cd6ff9bca80bd6407b58c8252167b655fb"
	    }
	 }
		*/
  service.logout = function() {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/logout', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": []
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		奖品列表
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/prize_list

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "prize_list": [
	            {
	                "prize_id": 1,
	                "prize_name": "实物奖励1",
	                "prize_type": 2,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 2,
	                "prize_name": "实物奖励2",
	                "prize_type": 2,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 3,
	                "prize_name": "实物奖励3",
	                "prize_type": 2,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 4,
	                "prize_name": "虚拟奖励1",
	                "prize_type": 1,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 5,
	                "prize_name": "虚拟奖励2",
	                "prize_type": 1,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 6,
	                "prize_name": "虚拟奖励3",
	                "prize_type": 1,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 7,
	                "prize_name": "虚拟奖励4",
	                "prize_type": 1,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            },
	            {
	                "prize_id": 8,
	                "prize_name": "虚拟奖励5",
	                "prize_type": 1,
	                "prize_icon": "https://static-xsjgw.xoyo.com/xsjgw/jx3/flagshipyy230518/98368343a664df78fddfe4fad4c99093.jpg"
	            }
	        ],
	        "session_id": "byZvvufHpACTLWP6DzIAyDfxziepA8puzFvACZ0j",
	        "request_id": "5c73887aac148da35420d58729710aa55f4b432e"
	    }
	 }
		*/
  service.prizeList = function() {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/prize_list', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "prize_list": "奖品列表"
          },
          "data{}.prize_list[]": {
            "prize_icon": "奖品icon",
            "prize_id": "奖励id",
            "prize_name": "奖品名称",
            "prize_type": "奖励类型:1=虚拟奖励,2=实物奖励"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得小程序二维码
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/get_qr_code?data_str=123456&env_version=trial&page=

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "img": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQ",
	        "pc_login_token": "681ef0b0be238f0942e4c11c5fb49bc0",
	        "effective_time": 300,
	        "session_id": "QoW6eQyTe24BDx16eOCjwg1v3aFULsIAKymEvXBA",
	        "request_id": "205c8d9219fe5981f4ee9bcaeaef411149541728"
	    }
	 }
		*/
  service.getQrCode = function(data_str, env_version, page) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/get_qr_code', {
      data_str: data_str /*  埋点参数（百度sem等,必传） */ ,
      env_version: env_version /*  小程序版本（正式版:release 体验版:trial 开发版:develop） */ ,
      page: page /*  小程序应该跳转到对应页面 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "effective_time": "二维码有效时间",
            "img": "小程序二维码",
            "pc_login_token": "pc登录token"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20102",
        "description": "当前账号未登录"
      }, {
        "code": "-20116",
        "description": "app_id不能为空"
      }, {
        "code": "-20118",
        "description": "未在小程序上完成预约"
      }, {
        "code": "-20120",
        "description": "获取二维码失败，请重试！"
      }, {
        "code": "-20121",
        "description": "网络繁忙，请稍后再试！"
      }, {
        "code": "-20123",
        "description": "您已预约"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		通过token获得pc埋点信息
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/get_data_str_by_token?token=b7a1202c33bdd9fa43a5e449b4111633

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "data_str": "123456",
	        "session_id": "QoW6eQyTe24BDx16eOCjwg1v3aFULsIAKymEvXBA",
	        "request_id": "15365b89bf184c60b2c03b10aa62f2566a0cfba5"
	    }
	 }
		*/
  service.getDataStrByToken = function(token) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/get_data_str_by_token', {
      token: token /*  token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "data_str": "埋点信息"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20122",
        "description": "小程序二维码已过期，请刷新页面后再扫码登录"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		pc端二维码检测小程序预约情况
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/check_pc_login_status?token=b7a1202c33bdd9fa43a5e449b4111633

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "is_login": 0,
	        "display_phone": "",
	        "session_id": "QoW6eQyTe24BDx16eOCjwg1v3aFULsIAKymEvXBA",
	        "request_id": "9288d76d464ae9ac5b6cbda4df4304bc13545c7b"
	    }
	 }
		*/
  service.checkPcLoginStatus = function(token) {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/check_pc_login_status', {
      token: token /*  token信息 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "display_phone": "展示手机号",
            "is_login": "是否已预约（1：已预约，0：未预约）"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }]
      		*/
      return reject(response);
    });
  };
  /**
		获得预约数据
		请求方法: GET, POST
		请求示例: http://<domain>/webapp/jxqyzyy240226/get_subscribe_data

	响应示例: 

	{
	    "code": 1,
	    "status": 1,
	    "msg": "",
	    "message": "",
	    "data": {
	        "real_count": 4,
	        "fake_count": 118320,
	        "request_id": "8527f22c83dcb186544f2391631546a07997ed0b"
	    }
	 }
		*/
  service.getSubscribeData = function() {
    return request.jsonp(rootAddress + '/webapp/jxqyzyy240226/get_subscribe_data', {}).then((response) => {
      if (response.status === 1 /* 成功 */ ) {
        /**
        {
          "data{}": {
            "web_show_count": "网站展示预约数",
            "real_count": "真实预约人数"
          }
        }
        		*/
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-20125",
        "description": "没有权限访问"
      }]
      		*/
      return reject(response);
    });
  };
  return service;
}